import { render, staticRenderFns } from "./IbNavigationButtonBack.vue?vue&type=template&id=30aa26ea&scoped=true"
import script from "./IbNavigationButtonBack.vue?vue&type=script&lang=js"
export * from "./IbNavigationButtonBack.vue?vue&type=script&lang=js"
import style0 from "./IbNavigationButtonBack.vue?vue&type=style&index=0&id=30aa26ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aa26ea",
  null
  
)

export default component.exports